var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isAccountsReceivable && _vm.timeEntry.sendEmail === "Yes"
        ? _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-2 control-label",
                attrs: { for: "attachInvoice" }
              },
              [_vm._v("\n            Attach invoice to email?\n        ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c("div", { staticClass: "radio" }, [
                _c(
                  "label",
                  {
                    staticClass: "radio-inline",
                    attrs: { for: "attachInvoiceYes" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.timeEntry.attachInvoice,
                          expression: "timeEntry.attachInvoice"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        name: "attachInvoice",
                        id: "attachInvoiceYes",
                        value: "Yes",
                        disabled: _vm.timeEntry.isAuditEdit
                      },
                      domProps: {
                        checked: _vm._q(_vm.timeEntry.attachInvoice, "Yes")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.timeEntry, "attachInvoice", "Yes")
                        }
                      }
                    }),
                    _vm._v("\n                    Yes\n                ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "radio-inline",
                    attrs: { for: "attachInvoiceNo" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.timeEntry.attachInvoice,
                          expression: "timeEntry.attachInvoice"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        name: "attachInvoice",
                        id: "attachInvoiceNo",
                        value: "No",
                        disabled: _vm.timeEntry.isAuditEdit
                      },
                      domProps: {
                        checked: _vm._q(_vm.timeEntry.attachInvoice, "No")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.timeEntry, "attachInvoice", "No")
                        }
                      }
                    }),
                    _vm._v("\n                    No\n                ")
                  ]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.timeEntry.sendEmail === "Yes" && !_vm.$store.getters.isEditForm
        ? _c("email-to", { on: { contactPickerClick: _vm.pickContact } })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.restrictedEditMode && _vm.timeEntry.emailTo
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-sm-2 control-label" }, [
              _vm._v("To:")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8 col-md-6" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", disabled: "disabled" },
                domProps: { value: _vm.timeEntry.emailTo }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      (!_vm.$store.getters.isEditForm || _vm.disabled) &&
      (_vm.timeEntry.sendEmail === "Yes" || _vm.timeEntry.sendEmail === null)
        ? _c(
            "div",
            {
              staticClass: "form-group",
              class: { "has-error": _vm.errors.has("emailFrom") }
            },
            [
              _c(
                "label",
                {
                  staticClass: "col-sm-2 control-label",
                  attrs: { for: "emailFrom" }
                },
                [_vm._v("From:")]
              ),
              _vm._v(" "),
              !_vm.$store.getters.restrictedEditMode
                ? _c("div", { staticClass: "col-sm-8 col-md-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required",
                          expression: "'required'",
                          modifiers: { disable: true }
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        "data-vv-as": "from",
                        type: "text",
                        id: "emailFrom",
                        name: "emailFrom",
                        disabled: "disabled"
                      },
                      domProps: { value: _vm.emailFrom }
                    }),
                    _vm._v(" "),
                    _vm.errors.has("emailFrom")
                      ? _c("p", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.errors.first("emailFrom")))
                        ])
                      : _vm._e()
                  ])
                : _vm.timeEntry.sendEmail === "Yes"
                ? _c("div", { staticClass: "col-sm-8 col-md-6" }, [
                    _c("input", {
                      staticClass: "form-control",
                      attrs: { type: "text", disabled: "disabled" },
                      domProps: { value: _vm.emailFrom }
                    })
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.timeEntry.sendEmail === "Yes" || _vm.disabled
        ? [
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-error": _vm.errors.has("comment") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "col-sm-2 control-label",
                    attrs: { for: "comment" }
                  },
                  [_vm._v("Subject:")]
                ),
                _vm._v(" "),
                !_vm.disabled
                  ? _c("div", { staticClass: "col-sm-10 col-md-8" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.disable",
                            value: "required",
                            expression: "'required'",
                            modifiers: { disable: true }
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.timeEntry.comment,
                            expression: "timeEntry.comment"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          "data-vv-as": "subject",
                          type: "text",
                          id: "comment",
                          name: "comment",
                          placeholder: "Enter the subject for the email",
                          maxlength: "100 "
                        },
                        domProps: { value: _vm.timeEntry.comment },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.timeEntry,
                              "comment",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.has("comment")
                        ? _c("p", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.errors.first("comment")))
                          ])
                        : _vm._e()
                    ])
                  : _c("div", { staticClass: "col-sm-6" }, [
                      _c("p", [_vm._v(_vm._s(_vm.timeEntry.comment))])
                    ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-error": _vm.errors.has("noteText") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "col-sm-2 control-label",
                    attrs: { for: "noteText" }
                  },
                  [_vm._v("Message:")]
                ),
                _vm._v(" "),
                !_vm.disabled
                  ? _c("div", { staticClass: "col-sm-10 col-md-8" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.disable",
                            value: "required",
                            expression: "'required'",
                            modifiers: { disable: true }
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.timeEntry.noteText,
                            expression: "timeEntry.noteText"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          "data-vv-as": "Message",
                          rows: "3",
                          id: "noteText",
                          name: "noteText"
                        },
                        domProps: { value: _vm.timeEntry.noteText },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.timeEntry,
                              "noteText",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.has("noteText")
                        ? _c("p", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.errors.first("noteText")))
                          ])
                        : _vm._e()
                    ])
                  : _c("div", { staticClass: "col-sm-10 col-md-8" }, [
                      _c(
                        "p",
                        [
                          _c("note-body", {
                            attrs: {
                              "note-text": _vm.timeEntry.noteText,
                              collapsible: false
                            }
                          })
                        ],
                        1
                      )
                    ])
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ff5815a", { render: render, staticRenderFns: staticRenderFns })
  }
}